import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {AccountFeaturesEnum} from "@app/interfaces/config/accountFeaturesEnum";
import {PermissionEnum} from '@app/enums/permissions/PermissionEnum';
import {EInvoiceBadgeService} from "@app/services/einvoice-badge.service";

@Component({
    selector: 'app-administration-sidebar',
    templateUrl: './administration-sidebar.component.html',
    styleUrls: ['./administration-sidebar.component.scss'],
    standalone: false
})
export class AdministrationSidebarComponent implements OnInit, OnDestroy {
  opened = true;
  public AccountFlagEnum = AccountFeaturesEnum;
  public incomingBadgeCount = 0;
  public invoicesBadgeCount = 0;
  public advancesBadgeCount = 0;
  public incomingBadgeTooltip = $localize`:@@admin.sidebar.incoming.tooltip:E-računi, ki čakajo na odobritev ali zavrnitev`;
  public invoicesBadgeTooltip = $localize`:@@admin.sidebar.outgoing.tooltip:Odobreni e-računi, ki čakajo na vnos plačila`;
  public advancesBadgeTooltip = $localize`:@@admin.sidebar.advances.tooltip:Odobreni avansni e-računi, ki čakajo na vnos plačila`;

  private destroy$ = new Subject<void>();

  constructor(private eInvoiceBadgeService: EInvoiceBadgeService) {
  }

  ngOnInit(): void {
    this.eInvoiceBadgeService.incoming$
      .pipe(takeUntil(this.destroy$))
      .subscribe((count) => this.incomingBadgeCount = count);

    this.eInvoiceBadgeService.invoices$
      .pipe(takeUntil(this.destroy$))
      .subscribe((count) => this.invoicesBadgeCount = count);

    this.eInvoiceBadgeService.advances$
      .pipe(takeUntil(this.destroy$))
      .subscribe((count) => this.advancesBadgeCount = count);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  toggleInvoices() {
    this.opened = !this.opened;
  }

  protected readonly PermissionEnum = PermissionEnum;
}
